import React from "react";
import MenuItem from "../Menu/MenuItem";
import { SideMenuWrapper } from "./Index";
import { SIDEMENU } from "./../../framework/consts/menuTypes";

const SideMenu = (props) => {
	const { AriaLabel, MenuItems } = props;
	let depth = 1;
	return (
		<SideMenuWrapper aria-label={AriaLabel} role="navigation">
			<MenuItem
				LastItem={true}
				Depth={depth}
				{...MenuItems}
				Display={MenuItems.Children.length > 0}
				MenuType={SIDEMENU}
			/>
		</SideMenuWrapper>
	);
};

export default SideMenu;
